module.exports = __webpack_public_path__ + "assets/e994ca254294492d35e9a00784f500e9.mp3";